
import React, {Component} from 'react';
import { Button } from '@material-ui/core';

import {  DateTimeDisplay } from 'core/Display';
import { ListProvider, ListContext } from 'core/ListProvider';

import { StyledChangesList, StyledChangesItem, Rectangle, ChangesLine } from './Styled';
import { filterHistoryItems } from './filterHistory';


export default class ChangesList extends Component {
  render() {
    const { item } = this.props;
    const { meta } = item;
    return (
      <ListProvider
        url={`changes/${meta.content_type_id}/${item.id}`}
        filterDefaults={{
          page_size: 10
        }}
      >
        <ListContext.Consumer>
          {context => {
            const { items, loading, pagination } = context;
            const visibleItems = filterHistoryItems(items);
            return (
              <StyledChangesList>
                <h2>История изменений</h2>
                {visibleItems.map(item => (
                  <StyledChangesItem key={item.id}>
                    <div className={'pt-2'}><Rectangle className={`action-${item.action}`} /></div>
                    <div>
                      <div className={'repr mb-10'}>{item.repr}</div>
                      {item.change_reason && (
                        <div className={'change_reason mt-10'}>{item.change_reason}</div>
                      )}

                      <div className={'info'}>
                        <div className={'mb-5'}><DateTimeDisplay value={item.created} /></div>
                        <div>{item.user.short_name || item.user.username}</div>
                      </div>

                      {(item.changes && item.changes.length) > 0 && (
                        <div className={'mt-10'}>
                          {item.changes.map((change, index) =>
                            <ChangesLine key={index}>
                              <div className={'label'}>{change.label}</div>
                              <div className={'value'}>{change.new_value ? change.new_value : '-'}</div>
                            </ChangesLine>
                          )}
                        </div>
                      )}
                    </div>
                  </StyledChangesItem>
                ))}

                {(pagination && pagination.next_link) && (
                  <Button
                    variant={'outlined'}
                    disabled={loading}
                    onClick={() => context.loadNext()}
                  >
                    Загрузить еще
                  </Button>
                )}
              </StyledChangesList>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
